<template>
  <div class="talent-filter-group-list">
    <div class="default-group">
      <div class="default-group-title">
        <span class="default-group-name">{{ defaultGroup.name }}:</span>
        <span class="default-group-count">{{ defaultGroup.report.total_count|formatBigNumber }}</span>
      </div>
      <div class="default-report-content">
        <div class="default-group-left">
          <div ref="reportChartDefault" class="default-group-chart"></div>
          <div class="default-report-items">
            <div class="default-group-item" v-for="(reportItem, index) in defaultGroup.report.items" :key="index">
              <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
              <div
                class="report-item report-item-name"
                @click="goToTalentPool(reportItem.name, defaultGroup.id)"
                :title="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)">{{reportItem.name}}</div>
              <div class="report-item">{{ reportItem.count|formatBigNumber }}</div>
            </div>
          </div>
        </div>
        <el-divider class="default-group-divider" direction="vertical"></el-divider>
        <div class="default-group-right">
          <div class="default-view-icon icon-pointer" @click="handleView(defaultGroup)"><i class="icon iconfont iconeye-fill"></i></div>
        </div>
      </div>
    </div>
    <div class="user-group-tainer">
      <div class="search-conditions">
        <div class="search-condition-keyword">
          <el-input v-model="searchCondition.keyword" :placeholder="$t('admin.crm.placeholder.talentFilterGroup.keywordSearch')" @keyup.enter.native="handleSearchBtnClick">
            <el-button slot="append" icon="el-icon-search" @click="handleSearchBtnClick"></el-button>
          </el-input>
        </div>
        <div class="search-condition-right">
          <div class="search-condition-visibility">
            <el-select v-model="searchCondition.visibility" @change="handleVisibilityConditionChange" >
              <el-option
                v-for="(item, key) in visibilityType"
                :key="key"
                :label="$t(item.i18nKey)"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="search-condition-creator">
            <el-select  v-model="searchCondition.creator" @change="handleCreatorConditionChange" >
              <el-option
                v-for="(item, key) in creatorList"
                :key="key"
                :label="getCreatorLabel(item)"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="user-group-list">
        <div class="user-group" v-for="item in userGroupList" :key="item.id">
          <div class="user-group-parent" :style="item.showGroupChildren ? 'margin-bottom: 0px;' : 'margin-bottom: 20px;'">
            <div class="group-left">
              <div class="group-name name-overflow" :title="item.name">{{ item.name }}</div>
              <div class="group-show-children" v-show="item.children.length > 0" @click="handleChangeGroupChildrenShow(item)"><i :class="item.showGroupChildren ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i></div>
              <div class="group-count" :style="item.children.length === 0 ? 'margin-top: 10px;': 'margin-top: -10px;'">
                <el-badge :value="(item.report.new_count < 0 ? '' : '+') + formatBigNumber(item.report.new_count)"></el-badge>
                <div class="total-count">{{ item.report.total_count|formatBigNumber }}</div>
              </div>
            </div>
            <el-divider class="group-divider" direction="vertical"></el-divider>
            <div class="group-middle">
              <div :ref="`reportChart_${item.id}`" class="group-middle-left"></div>
              <div class="group-middle-right">
                <div class="group-middle-right-item" v-for="(reportItem, index2) in item.report.items" :key="index2">
                  <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
                  <div class="report-item report-item-name name-overflow" :title="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)" @click="goToTalentPool(reportItem.name, item.id)">{{reportItem.name}}</div>
                  <div class="report-item">{{ reportItem.count|formatBigNumber }}</div>
                </div>
              </div>
            </div>
            <el-divider class="group-divider" direction="vertical"></el-divider>
            <div class="group-right">
              <el-row class="group-creator">
                <el-col class="group-right-lable" :span="10">{{ $t('admin.crm.label.talentFilterGroup.creator') }}</el-col>
                <el-col class="group-creator-name name-overflow" :span="14">{{ item.creator.full_name }}</el-col>
              </el-row>
              <el-row>
                <el-col class="group-right-lable" :span="10">{{ $t('admin.crm.label.talentFilterGroup.private') }}</el-col>
                <el-col class="group-visibility" :span="14">
                  <el-switch
                    v-if="refreshSwitch"
                    v-model="item.isPrivate"
                    :active-text="$t('common.yes')"
                    :inactive-text="$t('common.no')"
                    active-color="#7ccc82"
                    @change="handleVisibilitySwitch(item)"
                    :width="switchWidth"
                    :disabled="item.creator.id != currentUser.id"
                    ></el-switch></el-col>
              </el-row>
            </div>
            <div class="view-icon icon-pointer" @click="handleView(item)"><i class="icon iconfont iconeye-fill"></i></div>
            <div v-if="item.creator.id == currentUser.id" class="delete-icon icon-pointer" @click="handleDelete(item)"><i class="el-icon-delete"></i></div>
          </div>

          <div class="user-group-children" v-show="item.showGroupChildren" v-for="(child, childIndex) in item.children" :key="child.id" :style="(item.showGroupChildren && childIndex === item.children.length - 1) ? 'margin-bottom: 20px;' : 'margin-bottom: 0px;'">
            <div class="group-left">
              <div class="group-name name-overflow" :title="child.name">{{ child.name }}</div>
              <div class="group-count">
                <el-badge :value="(child.report.new_count < 0 ? '' : '+') + formatBigNumber(child.report.new_count)"></el-badge>
                <div class="total-count">{{ child.report.total_count|formatBigNumber }}</div>
              </div>
            </div>
            <el-divider class="group-divider" direction="vertical"></el-divider>
            <div class="group-middle">
              <div :ref="`childReportChart_${child.id}`" class="group-middle-left"></div>
              <div class="group-middle-right">
                <div class="group-middle-right-item" v-for="(reportItem, index2) in child.report.items" :key="index2">
                  <div class="report-item-circle" :class="`circle-${reportItem.name.toLowerCase()}`"></div>
                  <div class="report-item report-item-name name-overflow" :title="$t(`admin.crm.label.talent.candidateStatus.${reportItem.name.toLowerCase()}`)" @click="goToTalentPool(reportItem.name, child.id)">{{reportItem.name}}</div>
                  <div class="report-item">{{ reportItem.count|formatBigNumber }}</div>
                </div>
              </div>
            </div>
            <el-divider class="group-divider" direction="vertical"></el-divider>
            <div class="group-right">
              <el-row class="group-creator">
                <el-col class="group-right-lable" :span="10">{{ $t('admin.crm.label.talentFilterGroup.creator') }}</el-col>
                <el-col class="group-creator-name name-overflow" :span="14">{{ child.creator.full_name }}</el-col>
              </el-row>
              <el-row>
                <el-col class="group-right-lable" :span="10">{{ $t('admin.crm.label.talentFilterGroup.private') }}</el-col>
                <el-col class="group-visibility" :span="14">
                  <el-switch
                    v-if="refreshSwitch"
                    v-model="child.isPrivate"
                    :active-text="$t('common.yes')"
                    :inactive-text="$t('common.no')"
                    active-color="#7ccc82"
                    @change="handleVisibilitySwitch(child)"
                    :width="switchWidth"
                    :disabled="child.creator.id != currentUser.id"
                    ></el-switch></el-col>
              </el-row>
            </div>
            <div class="view-icon icon-pointer" @click="handleView(child)"><i class="icon iconfont iconeye-fill"></i></div>
            <div v-if="child.creator.id == currentUser.id" class="delete-icon icon-pointer" @click="handleDelete(child)"><i class="el-icon-delete"></i></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showDeleteDialog">
      <span>{{ this.$t('admin.crm.message.talentFilterGroup.deleteConfirm') }}</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDeleteDialog = false">{{ $t('common.btn.cancel') }}</el-button>
        <el-button type="primary" @click="onDeleteOkBtnclick">{{ $t('common.btn.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VISIBILITY_TYPE } from '@/constant/crm'
import * as echarts from 'echarts'
import _ from 'lodash'
import { formatBigNumber } from '@/components/filters'
window.echarts = echarts

const CHART_OPTION = {
  tooltip: {
    show: false,
    formatter: 'The report is in generating...'
  },
  dataset: {
  },
  angleAxis: {
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  radiusAxis: {
    type: 'category',
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  polar: {
    radius: ['30%', '80%']
  },
  series: [
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#ec7a3b'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#f1d45f'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#98cd95'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#b0dde2'
      },
      stack: 'a'
    },
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      itemStyle: {
        color: '#6dadc8'
      },
      stack: 'a'
    }
  ],
  legend: {
  }
}

export default {
  components: {
  },
  data () {
    return {
      formatBigNumber,
      refreshSwitch: true,
      showDeleteDialog: false,
      visibilityType: VISIBILITY_TYPE,
      searchCondition: {
        keyword: null,
        creator: 'all',
        visibility: 'all'
      },
      currentUser: {},
      defaultGroup: {
        name: '',
        report: {
          items: [
            {
              name: 'Hot',
              count: 0
            },
            {
              name: 'Active',
              count: 0
            },
            {
              name: 'Warm',
              count: 0
            },
            {
              name: 'Potential',
              count: 0
            },
            {
              name: 'Cold',
              count: 0
            }
          ]
        }
      },
      countNameOrder: ['Hot', 'Active', 'Warm', 'Potential', 'Cold'],
      activeItem: {
      },
      userGroupList: [],
      creatorList: [
        { id: 'all', name: 'allCreator' }
      ]
    }
  },
  computed: {
    switchWidth () {
      if (this.$i18n.locale === 'en') {
        return 55
      } else {
        return 50
      }
    }
  },
  async created () {
    this.initSearchCondition()
    await this.getTalentFilterGroupList()
    this.currentUser = this.getCurrentAccount()
    const creatorIdList = { [this.currentUser.id]: this.currentUser.id }
    const creatorList = this.userGroupList.filter(item => {
      const creatorId = item.creator.id
      const hasProp = creatorIdList.hasOwnProperty(item.creator.id)
      if (!hasProp) {
        creatorIdList[creatorId] = creatorId
      }
      return !hasProp
    }).map(item => {
      return {
        id: item.creator.id,
        name: item.creator.full_name
      }
    })
    this.creatorList = this.creatorList.concat([{
      id: this.currentUser.id,
      name: 'my'
    }]).concat(creatorList)
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    ...mapActions('crm', ['changeTalentPoolSearchCondition']),
    ...mapActions('talent', ['searchTalentFilterGroup', 'updateTalentFilterGroupInfo', 'deleteTalentFilterGroup']),
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapGetters('crm', ['getTalentPoolSearchCondition']),
    async getTalentFilterGroupList () {
      const resp = await this.searchTalentFilterGroup(this.searchCondition)
      if (resp) {
        const reportNameList = _.map(resp.default_group.report.items, 'name')
        this.countNameOrder = _.filter(this.countNameOrder, name => reportNameList.includes(name))
        _.forEach([resp.default_group, ...resp.user_groups], item => {
          const report = item.report
          report.items = _.map(this.countNameOrder, name => _.find(report.items, { name }))
        })
        this.defaultGroup = resp.default_group
        this.userGroupList = _.map(resp.user_groups, this.convertFilterGroup)
        const children = []
        _.forEach(this.userGroupList, (group, index) => {
          if (group && group.parent_id) {
            children.push(group)
          }
        })
        if (this.userGroupList.length > 1) {
          this.userGroupList = this.userGroupList.filter((groupParent) => !children.some((child) => groupParent.id === child.id))
        }
        _.forEach(this.userGroupList, group => {
          const groupId = group.id
          const groupChildren = _.filter(children, child => child.parent_id === groupId)
          this.$set(group, 'children', groupChildren)
        })
      }
    },
    handleChangeGroupChildrenShow (item) {
      if (!item.showGroupChildren) {
        this.$set(item, 'showGroupChildren', false)
      }
      this.$set(item, 'showGroupChildren', !item.showGroupChildren)
      if (item.showGroupChildren) {
        this.initUserGroupChildrenChart(item)
      }
    },
    initChart () {
      this.initUserGroupChart()
      this.initDefaultGroupChart()
    },
    initSearchCondition () {
      const condition = this.getTalentPoolSearchCondition()
      if (condition.creator) {
        this.searchCondition.creator = condition.creator
      }
      if (condition.visibility) {
        this.searchCondition.visibility = condition.visibility
      }
    },
    initUserGroupChart () {
      this.userGroupList.forEach((item) => {
        const myChart = echarts.init(this.$refs[`reportChart_${item.id}`][0])
        const report = item.report
        let option
        if (!report.items.find(item => item.count !== 0)) {
          option = this.getInProgressChartOption(report, item.id)
        } else {
          option = this.getDoneChartOption(report, item.id)
        }
        myChart.setOption(option)
        this.initChartClickEvent(myChart)
      })
    },
    initUserGroupChildrenChart (item) {
      _.forEach(item.children, group => {
        const childChart = echarts.init(this.$refs[`childReportChart_${group.id}`][0])
        const childReport = group.report
        let childOption
        if (!childReport.items.find(group => group.count !== 0)) {
          childOption = this.getInProgressChartOption(childReport, group.id)
        } else {
          childOption = this.getDoneChartOption(childReport, group.id)
        }
        childChart.setOption(childOption)
        this.initChartClickEvent(childChart)
      })
    },
    initDefaultGroupChart () {
      const myChart = echarts.init(this.$refs.reportChartDefault)
      let option
      const report = this.defaultGroup.report
      if (!report.items.find(item => item.count !== 0)) {
        option = this.getInProgressChartOption(report, this.defaultGroup.id)
      } else {
        option = this.getDoneChartOption(report, this.defaultGroup.id)
      }
      myChart.setOption(option)
      this.initChartClickEvent(myChart)
    },
    initChartClickEvent (myChart) {
      myChart.on('click', (params) => {
        const nameArray = params.name.split('_')
        const activeness = nameArray[0]
        const talentFilterGroupId = nameArray[1]
        this.goToTalentPool(activeness, talentFilterGroupId)
      })
    },
    goToTalentPool (activeness, talentFilterGroupId) {
      if (activeness === 'Potential') {
        window.localStorage.setItem('talent_pool_tab', 5)
        window.localStorage.setItem('talent_pool_order', '-last_active_time')
      }
      window.location.href = this.$DjangoBaseUrl(`talent-pool/?talent-filter-group-id=${talentFilterGroupId}&activeness=${activeness}`)
    },
    getInProgressChartOption (report, talentFilterGroupId) {
      const option = JSON.parse(JSON.stringify(CHART_OPTION))
      option.dataset = {
        source: _.map(report.items, (reportItem, index) => {
          const dataItem = _.map(this.defaultGroup.report.items, item => 0)
          if (reportItem.name === 'Cold') {
            dataItem[index] = 100
          }
          const name = reportItem.name + '_' + talentFilterGroupId
          return [
            name,
            ...dataItem
          ]
        })
      }
      option.angleAxis.max = 100
      option.series[option.series.length - 1].itemStyle.color = '#dcdfe6'
      option.tooltip.show = true
      option.tooltip.formatter = (params, ticket, callback) => {
        return this.$t('admin.crm.tooltip.talentFilterGroup.generatingReport')
      }

      return option
    },
    getDoneChartOption (report, talentFilterGroupId) {
      const option = JSON.parse(JSON.stringify(CHART_OPTION))
      let maxCount = report.total_count
      const emptyCount = _.map(this.countNameOrder, _.constant(0))
      option.dataset = {
        source: _.map(report.items, (item, index) => {
          const name = item.name
          const count = item.count
          if (count > maxCount) {
            maxCount = count
          }
          const data = [`${name}_${talentFilterGroupId}`, ...emptyCount]
          data[index + 1] = count
          return data
        })
      }
      if (!this.countNameOrder.includes('Potential')) {
        option.series.splice(3, 1)
      }
      option.angleAxis.max = maxCount
      return option
    },
    convertFilterGroup (group) {
      const filterGroup = {
        ...group,
        isPrivate: !group.is_public
      }

      return filterGroup
    },
    getCreatorLabel (creator) {
      if (creator.name === 'allCreator') {
        return this.$t('admin.crm.option.talentFilterGroup.allCreator')
      } else if (creator.name === 'my') {
        return this.$t('admin.crm.option.talentFilterGroup.my')
      } else {
        return creator.name
      }
    },
    handleVisibilityConditionChange () {
      this.changeTalentPoolSearchCondition({ key: 'visibility', value: this.searchCondition.visibility })
      this.refreshUserGroupList()
    },
    handleCreatorConditionChange () {
      this.changeTalentPoolSearchCondition({ key: 'creator', value: this.searchCondition.creator })
      this.refreshUserGroupList()
    },
    handleSearchBtnClick () {
      this.refreshUserGroupList()
    },
    async refreshUserGroupList () {
      let needFetch = true
      // only the creator can view the private filter group
      if (this.searchCondition.visibility === 'private') {
        if (this.searchCondition.creator !== this.currentUser.id && this.searchCondition.creator !== 'all') {
          needFetch = false
        }
      }

      if (needFetch) {
        await this.getTalentFilterGroupList()
      } else {
        this.userGroupList = []
      }

      this.$nextTick(() => {
        this.initChart()
      })
    },
    async handleVisibilitySwitch (group) {
      group.is_public = !group.isPrivate
      const groupDetail = group
      await this.updateTalentFilterGroupInfo(groupDetail)
      this.refreshUserGroupList()
    },
    async handleDelete (group) {
      this.activeItem = group
      this.showDeleteDialog = true
    },
    async onDeleteOkBtnclick () {
      await this.deleteTalentFilterGroup(this.activeItem.id)
      this.refreshUserGroupList()
      this.showDeleteDialog = false
    },
    handleView (group) {
      window.location.href = this.$DjangoBaseUrl(`talent-pool/?talent-filter-group-id=${group.id}`)
    }
  },
  watch: {
    switchWidth (newValue, oldValue) {
      this.refreshSwitch = false
      this.$nextTick(() => {
        this.refreshSwitch = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.talent-filter-group-list {
  padding: 20px 40px 20px 40px;
  .default-group {
    border: 1px solid #DCDFE6;
    margin-bottom: 10px;
    .default-group-title {
      margin-top: 20px;
      text-align: center;
      .default-group-name {
          font-size: 28px;
      }
      .default-group-count {
        font-size: 46px;
        font-weight: bold;
        margin-left: 15px;
        color: #0296cc;
      }
    }
    .default-report-content {
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      .default-group-left {
        display: flex;
        flex-grow: 3;
        align-items: center;
        .default-group-chart {
          flex-grow: 2;
          width: 200px;
          height: 200px;
          margin-left: 100px;
          margin-bottom: 15px;
        }
        .default-report-items {
          flex-grow: 1;
          .default-group-item {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            .report-item {
              font-size: 16px;
            }
            .report-item-name {
              width: 100px;
            }
          }
        }
      }
      .default-group-divider {
          height: 80%;
          margin: 10px 18px 10px 5px;
      }
      .default-group-right {
        flex-grow: 1;
        text-align: center;
        .default-view-icon {
          color: #2698ca;
          .iconfont {
            font-size: 24px;
          }
        }
      }
    }
  }
  .user-group-tainer {
    margin-top: 35px;
    .search-conditions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      ::v-deep {
        .el-input--suffix .el-input__inner {
          color: #409EFF;
          border: none;
        }
        .el-icon-arrow-up::before {
          content: '\e78f';
        }
      }
      .search-condition-keyword {
        width: 350px;
        ::v-deep {
          .el-input-group--append {
            .el-input__inner {
              height: 30px;
              line-height: 30px;
            }
            .el-input-group__append {
              padding: 0 10px;
            }
          }
        }
      }
      .search-condition-right {
        display: flex;
        justify-content: flex-end;
        .search-condition-visibility {
          width: 73px;
        }
        .search-condition-creator {
          width: 114px;
        }
      }
    }
    .user-group-list {
      margin-top: 10px;
      .user-group {
        .user-group-parent {
          background: #FAFAFA;
          border: 1px solid #DCDFE6;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          height: 150px;
          position: relative;
          .group-left {
            width: 300px;
            .group-name {
              width: inherit;
              text-align: center;
              font-size: 24px;
              padding: 0 10px;
            }
            .group-show-children {
              margin-left: 20px;
              margin-bottom: -20px;
              font-size: 24px;
              i {
                color: #606266;
              }
            }
            .group-count {
              margin-top: -10px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              .total-count {
                margin-left: 10px;
                font-size: 40px;
                color: #0296cc;
              }
              ::v-deep {
                .el-badge__content {
                  background-color: #b1b1b1;
                  line-height: 16px;
                }
              }
            }
          }
          .group-divider {
            height: 80%;
            margin: 10px 10px 10px 5px;
          }
          .group-middle {
            width: 400px;
            display: flex;
            align-items: center;
            .group-middle-left {
              width: 150px;
              height: 150px;
              margin-left: 20px;
            }
            .group-middle-right {
              margin-left: 55px;
              .group-middle-right-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
              }
            }
          }
          .group-right {
            width: 150px;
            margin-left: 5px;
            margin-right: 15px;
            .group-creator {
              margin-bottom: 10px;
              .group-creator-name {
                color: #8a8a8a;
                font-size: 14px;
              }
            }
            .group-visibility {
              position: relative;
              .el-switch {
                ::v-deep {
                  .el-switch__label {
                    display: none;
                    position: absolute;
                    height: 100%;
                    color: #ffffff;
                    z-index: 1;
                    margin: 0;
                    &.is-active {
                      display: inline-block;
                    }
                  }
                  .el-switch__label--left {
                    left: 25px;
                  }
                  .el-switch__label--right {
                    left: 10px;
                  }
                }
              }
            }
            .group-right-lable {
              color: #d1d1d1;
              font-size: 14px;
            }
          }
          .view-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #2698ca;
            .iconfont {
              font-size: 20px;
            }
          }
          .delete-icon {
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-size: 14px;
            color: #cacaca;
          }
        }

        .user-group-children {
          border: 1px solid #DCDFE6;
          display: flex;
          align-items: center;
          height: 150px;
          position: relative;
          .group-left {
            width: 300px;
            .group-name {
              width: inherit;
              text-align: center;
              font-size: 24px;
              padding: 0 10px;
            }
            .group-count {
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              .total-count {
                margin-left: 10px;
                font-size: 40px;
                color: #0296cc;
              }
              ::v-deep {
                .el-badge__content {
                  background-color: #b1b1b1;
                  line-height: 16px;
                }
              }
            }
          }
          .group-divider {
            height: 80%;
            margin: 10px 10px 10px 5px;
          }
          .group-middle {
            width: 400px;
            display: flex;
            align-items: center;
            .group-middle-left {
              width: 150px;
              height: 150px;
              margin-left: 20px;
            }
            .group-middle-right {
              margin-left: 55px;
              .group-middle-right-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
              }
            }
          }
          .group-right {
            width: 150px;
            margin-left: 5px;
            margin-right: 15px;
            .group-creator {
              margin-bottom: 10px;
              .group-creator-name {
                color: #8a8a8a;
                font-size: 14px;
              }
            }
            .group-visibility {
              position: relative;
              .el-switch {
                ::v-deep {
                  .el-switch__label {
                    display: none;
                    position: absolute;
                    height: 100%;
                    color: #ffffff;
                    z-index: 1;
                    margin: 0;
                    &.is-active {
                      display: inline-block;
                    }
                  }
                  .el-switch__label--left {
                    left: 25px;
                  }
                  .el-switch__label--right {
                    left: 10px;
                  }
                }
              }
            }
            .group-right-lable {
              color: #d1d1d1;
              font-size: 14px;
            }
          }
          .view-icon {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #2698ca;
            .iconfont {
              font-size: 20px;
            }
          }
          .delete-icon {
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-size: 14px;
            color: #cacaca;
          }
        }
      }
    }
  }
  .report-item-circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .circle-hot {
    background-color: #ec7a3b;
  }
  .circle-active {
    background-color: #f1d45f;
  }
  .circle-warm {
    background-color: #98cd95;
  }
  .circle-potential {
    background-color: #b0dde2;
  }
  .circle-cold {
    background-color: #6dadc8;
  }
  .report-item {
    font-size: 14px;
  }
  .report-item-name {
    margin-left: 15px;
    width: 70px;
    cursor: pointer;
  }
  .name-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .icon-pointer {
    cursor: pointer;
  }
  .dialog-footer {
    .delete-btn {
      margin-left: 35px;
      float: left;
    }
  }
}
.page-en {
  .talent-filter-group-list {
    .user-group-tainer {
      .search-conditions {
        .search-condition-right {
          .search-condition-visibility {
            width: 90px;
          }
          .search-condition-creator {
            width: 165px;
          }
        }
      }
    }
  }
}
</style>
